/**
 * Creates new scoped interval function
 * Return array of functions:
 *    [0]: ClearInterval;
 *    [1]: wrapping function;
 * @param {number} timeout - time in ms for callback call interval
 * @param {number} repeatTimes - count of callback repeats
 * @param {Function} callback - function to execute by interval
 * @example
 *    const [clearExecution, wrapper] = pollingUpdate(3000, 5);
 *    const pollingAction = wrapper(() => console.log(1), (var) => Promise.resolve(var));
 *    pollingAction("test"); // This will show `1` 5 times in 3 seconds delay
 * @return {[Function, Function]} - [0]: ClearInterval; [1]: wrapper function
 */
export const pollingUpdate = (timeout, repeatTimes) => {
  let intervalId = null;
  let intervalCallId = 0;

  /**
   * Stop scoped interval
   */
  function stopIntervalTask() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
      intervalCallId = 0;
    }
  }

  /**
   * Wraps `action` and after it's success initiate new polling update
   * @param {Promise} action
   * @return {Function}
   */
  const pollingUpdateActionWrapper = (callback, action) => (...data) => action(...data)
    .then((response) => {
      // Clear old interval (if any) if action is successfull
      stopIntervalTask();

      intervalId = setInterval(() => {
        // Increment counter
        intervalCallId += 1;
        // clear current interval if we done it
        if (intervalCallId >= repeatTimes) {
          stopIntervalTask();
        }
        // Executing callback action
        callback();
      }, timeout);
      return response;
    });

  return [stopIntervalTask, pollingUpdateActionWrapper];
};
